// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._HfCFhrG5_8sEnKRQFJ3 {\r\n  height: 535px;\r\n  background: white;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB","sourcesContent":[".dashboard {\r\n  height: 535px;\r\n  background: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": "_HfCFhrG5_8sEnKRQFJ3"
};
export default ___CSS_LOADER_EXPORT___;
